const IframeUtils = resolve =>
  require(['@/views/Others/Vyifarme'], resolve)

export default [
  {
    name: 'Vyifarme',
    path: '/Others/Vyifarme',
    component: IframeUtils,
    meta: {
      keepAlive: false,
      title: 'ifarme组件',
    },
  },
]



// WEBPACK FOOTER //
// ./src/router/others.js